import { render, staticRenderFns } from "./ManageAdminPage.vue?vue&type=template&id=567b47f7&scoped=true&"
import script from "./ManageAdminPage.vue?vue&type=script&lang=js&"
export * from "./ManageAdminPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageAdminPage.vue?vue&type=style&index=0&id=567b47f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b47f7",
  null
  
)

export default component.exports